import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import BGM from '@src/business-components/bgm';
import PageSwiper from '@src/components/swiper/page-swiper';
import createLazyComponent from '@src/utils/create-lazy-component';
import KvSection from '@src/pages/main/components/kv-section';
import Link from '@src/components/link';
import cx from 'classnames';
import Sidebar from '@src/business-components/sidebar';
import SnowfallBackground from './components/snowfall-background';
import RoleSection from '@src/pages/main/components/role-section';
const styles = require('./index.less');

const WelfareSectionLazy = createLazyComponent(() => import('@src/pages/main/components/welfare-section'));
const ReviewSectionLazy = createLazyComponent(() => import('@src/pages/main/components/review-section'));
// const RoleSectionLazy = createLazyComponent(() => import('@src/pages/main/components/role-section'));
const FeatureSectionLazy = createLazyComponent(() => import('@src/pages/main/components/feature-section'));
const FocusUsSectionLazy = createLazyComponent(() => import('@src/pages/main/components/focusUs-section'));
const DrawSectionLazy = createLazyComponent(() => import('@src/pages/main/components/draw-section'));

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      {/* 侧边栏 */}
      {store.pageSwiperIndex >= 1 && <Link className={styles.sideBarBtn} onClick={() => store.showSideBar()} />}
      <Sidebar store={store.sideBarStore} />
      {/* 背景音乐 */}
      <div className={cx(styles.music, store.pageSwiperIndex > 0 && styles.musicActive)}>
        <BGM store={store.bgm} />
      </div>
      {/* 分享 */}
      <div className={cx(styles.shareListBox, store.pageSwiperIndex > 0 && styles.shareListBoxActive)}>
        <div className={styles.shareIcon}>
          <div className={styles.shareList}>
            {store.shareConfig.map(item => <img key={item.key} src={item.icon} className={styles.shareItem} onClick={item.onShare} alt="" />)}
          </div>
        </div>
      </div>
      {/* 更多提示 */}
      {store.pageSwiperIndex !== 6 && <div className={styles.moreTips} />}

      <SnowfallBackground />
      {/* 轮播图 */}
      <PageSwiper store={store.pageSwiperStore}>
        <div className={styles.pageItem}>
          <KvSection store={store.kvSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <WelfareSectionLazy store={store.welfareSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <ReviewSectionLazy store={store.reviewSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <DrawSectionLazy store={store.drawSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <RoleSection store={store.roleSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <FeatureSectionLazy store={store.featureSectionStore} />
        </div>
        <div className={styles.pageItem}>
          <FocusUsSectionLazy store={store.focusUsSectionStore} />
        </div>
      </PageSwiper>
    </Page>
  );
};

export default observer(Main);
